import React, { lazy } from 'react';

const ContractDN = lazy(() =>
  import('../ClientContractListing/ClientContractListing').then(module => ({
    default: module.ClientContractListing,
  })),
);

const ContractLedgerForm = lazy(() =>
  import('../ClientContractForm/ContractDnForm').then(module => ({
    default: module.ContractDnForm,
  })),
);

const ContractLedgerDetail = lazy(() =>
  import('../ClientContractDetail/ContractDnDetail').then(module => ({
    default: module.ContractDnDetail,
  })),
);
//create new routes
const ContractDebitNotesPreview = lazy(() =>
  import('../ClientContractPDF/DebitNotesPreviewDetailPDF').then(module => ({
    default: module.DebitNotesPreviewDetailPDF,
  })),
);

const ClientPreviewDetailPDF = lazy(() =>
  import('../ClientContractPDF/ClientPreviewDetailPDF').then(module => ({
    default: module.ClientPreviewDetailPDF,
  })),
);

const ContractLedgerMobileView = lazy(() =>
  import(
    '../../AccountLedgerModule/AccountLedgerMobileView/DebitNotePDF/DebitNotePDFMobile'
  ).then(module => ({
    default: module.DebMobile,
  })),
);

const GLItemForm = lazy(() =>
  import('containers/SubconAccountModule/SubconForm/GLItemForm').then(
    module => ({
      default: module.GLItemForm,
    }),
  ),
);

export const ContractDNRoutes = [
  {
    props: {
      exact: true,
      path: `/contract/submenu/:contractID/account-status/debit-notes`,
    },
    component: (
      <ContractDN accountType="contract" transactionType="Debit Adjustment(DN Outwards)" />
    ),
  },
  {
    props: {
      exact: true,
      path: `/contract/submenu/:ID/account-status/debit-notes/detail/:transactionID`,
    },
    component: (
      <ContractLedgerDetail
        accountType="contract"
        transactionType="Debit Adjustment(DN Outwards)"
      />
    ),
  },
  {
    props: {
      exact: true,
      path: `/client-account/submenu/:ID/debit-notes`,
    },
    component: (
      <ContractDN accountType="client" transactionType="Debit Adjustment(DN Outwards)" />
    ),
  },
  {
    props: {
      exact: true,
      path: `/client-account/submenu/:ID/:contractID/debit-notes`,
    },
    component: (
      <ContractDN accountType="client" transactionType="Debit Adjustment(DN Outwards)" />
    ),
  },
  {
    props: {
      exact: true,
      path: '/client-account/submenu/:ID/:contractID/debit-notes/add',
    },
    component: (
      <ContractLedgerForm
        transactionType="Debit Adjustment(DN Outwards)"
        accountType="client"
        formMode="add"
      />
    ),
  },
  {
    props: {
      exact: true,
      path: `/client-account/submenu/:ID/:contractID/debit-notes/:formMode/item/:itemMode`,
    },
    component: <GLItemForm transactionType="Debit Adjustment(DN Outwards)" />,
  },
  {
    props: {
      exact: true,
      path: `/client-account/submenu/:ID/:contractID/debit-notes/:formMode/:transactionID/item/:itemMode`,
    },
    component: <GLItemForm transactionType="Debit Adjustment(DN Outwards)" />,
  },
  {
    props: {
      exact: true,
      path: `/client-account/submenu/:ID/:contractID/debit-notes/:formMode/item/:itemMode/:itemID`,
    },
    component: <GLItemForm transactionType="Debit Adjustment(DN Outwards)" />,
  },
  {
    props: {
      exact: true,
      path: `/client-account/submenu/:ID/:contractID/debit-notes/:formMode/:transactionID/item/:itemMode/:itemID`,
    },
    component: <GLItemForm transactionType="Debit Adjustment(DN Outwards)" />,
  },
  {
    props: {
      exact: true,
      path:
        '/client-account/submenu/:ID/:contractID/debit-notes/edit/:transactionID',
    },
    component: (
      <ContractLedgerForm
        transactionType="Debit Adjustment(DN Outwards)"
        accountType="client"
        formMode="edit"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/client-account/submenu/:ID/:contractID/debit-notes/approve-reject/:transactionID',
    },
    component: (
      <ContractLedgerForm
        transactionType="Debit Adjustment(DN Outwards)"
        accountType="client"
        formMode="approve-reject"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/client-account/submenu/:ID/:contractID/debit-notes/approve-reject/:refTable/workdesk/:transactionID',
    },
    component: (
      <ContractLedgerForm
        transactionType="Debit Adjustment(DN Outwards)"
        accountType="client"
        formMode="approve-reject"
        type="workdesk"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/client-account/submenu/:ID/:contractID/debit-notes/resubmit/:transactionID',
    },
    component: (
      <ContractLedgerForm
        transactionType="Debit Adjustment(DN Outwards)"
        accountType="client"
        formMode="resubmit"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/client-account/submenu/:ID/:contractID/debit-notes/detail/:transactionID',
    },
    component: (
      <ContractLedgerDetail
        transactionType="Debit Adjustment(DN Outwards)"
        accountType="client"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/client-account/submenu/:ID/:contractID/debit-notes/detail/workdesk/:transactionID',
    },
    component: (
      <ContractLedgerDetail
        transactionType="Debit Adjustment(DN Outwards)"
        accountType="client"
        state="workdesk"
      />
    ),
  },
  /////////////////////////
  //// MOBILE PDF VIEW ////
  /////////////////////////
  {
    props: {
      exact: true,
      path: '/client-account/submenu/:ID/:contractID/debit-notes/mobile-view',
    },
    component: (
      <ContractLedgerMobileView
        transactionType="Debit Adjustment(DN Outwards)"
        accountType="client"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/client-account/submenu/:ID/:contractID/debit-notes/:transactionID/mobile-view',
    },
    component: (
      <ContractLedgerMobileView
        transactionType="Debit Adjustment(DN Outwards)"
        accountType="client"
      />
    ),
  },
  //copy from above
  {
    props: {
      exact: true,
      path:
        '/client-account/submenu/:ID/:contractID/debit-notes/:transactionID/preview',
    },
    component: (
      //create new routing
      <ContractDebitNotesPreview
        transactionType="Debit Adjustment(DN Outwards)"
        accountType="client"
      />
    ),
  },
  /////////////////////ELETTER PREVIEW PDF///////////////
  {
    props: {
      exact: true,
      path:
        '/client-account/submenu/:ID/:contractID/debit-notes/:debitNoteID/e-letter',
    },
    component: (
      <ClientPreviewDetailPDF
        docType="debit-note"
        accountType="client-account"
      />
    ),
  },
];
